import { render, staticRenderFns } from "./Ml18ClienteFornecedor.vue?vue&type=template&id=49336086&"
import script from "./Ml18ClienteFornecedor.vue?vue&type=script&lang=js&"
export * from "./Ml18ClienteFornecedor.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Ml18ClienteFornecedor.vue?vue&type=style&index=1&id=49336086&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports